import {useSelector} from "react-redux";
import type {RootState} from "../../../store";
import {exceptionCells} from "../components/table/ConstructionTableProps";
import CheckForAcceptedMastFoundationFootplate from "../components/helpers/CheckForAcceptedMastFoundationFootplate";
import type GuiValueDto from "../../../dto/construction/GuiValueDto";

interface ConstructionTableRowCellHookParams {
  constructionElementParentId: string;
  constructionElementEntityId: string;
  constructionElementsName: string;
  constructionElementProperty: string;
  header: string;
  guiValue: GuiValueDto<string | number | boolean>;
  formatCell: (value: unknown) => string;
  displayIsaacToggleButton: (name: string, property: string) => boolean;
}
interface ConstructionTableRowCellHook {
  acceptedMast: React.ReactNode | null;
  isChecked: () => boolean;
}

const useConstructionTableRowCellHook = (params: ConstructionTableRowCellHookParams): ConstructionTableRowCellHook => {
  const {deselectedEntities} = useSelector((state: RootState) => state.constructionNew);
  const data = useSelector((state: RootState) => state.constructionNew.data);

  const isChecked = (): boolean => {
    const notSelectedEntity = deselectedEntities.find(de => de.entityId === params.constructionElementEntityId);
    return !notSelectedEntity;
  };

  const acceptedMast = CheckForAcceptedMastFoundationFootplate({
    data,
    constructionElementEntityId: params.constructionElementEntityId,
    constructionElementParentId: params.constructionElementParentId,
    constructionElementsName: params.constructionElementsName,
    constructionElementProperty: params.constructionElementProperty,
    isChecked,
    header: params.header,
    exceptionCells,
    guiValue: params.guiValue,
    formatCell: params.formatCell,
    displayIsaacToggleButton: params.displayIsaacToggleButton,
  });
  return {
    acceptedMast,
    isChecked,
  };
};

export default useConstructionTableRowCellHook;
